import { Expose } from 'class-transformer';
import { Model } from './Model';
import { IdeaWithVersion } from './Idea';

export class Pillar extends Model {
	private _organizationId: string | null = null;
	@Expose()
	set organizationId(v: string | null) { this._organizationId = v; }
	get organizationId(): string | null { return this._organizationId; }

	private _title: string | null = null;
	@Expose()
	set title(v: string | null) { this._title = v; }
	get title(): string | null { return this._title; }

	private _description: string | null = null;
	@Expose()
	set description(v: string | null) { this._description = v; }
	get description(): string | null { return this._description; }

	private _problemGoal: string | null = null;
	@Expose()
	set problemGoal(v: string | null) { this._problemGoal = v; }
	get problemGoal(): string | null { return this._problemGoal; }

	private _reasoning: string | null = null;
	@Expose()
	set reasoning(v: string | null) { this._reasoning = v; }
	get reasoning(): string | null { return this._reasoning; }

	private _sortOrder = 0;
	@Expose()
	set sortOrder(v: number) { this._sortOrder = v; }
	get sortOrder(): number { return this._sortOrder; }

	private _createdAt: Date | null = null;
	@Expose()
	set createdAt(v: Date | string | null) { this._createdAt = v ? new Date(v as string) : null; }
	get createdAt(): Date | null { return this._createdAt; }

	private _origin: 'admin' | 'community' = 'admin';
	@Expose()
	set origin(v: 'admin' | 'community') { this._origin = v; }
	get origin(): 'admin' | 'community' { return this._origin; }

	private _isDeleted = false;
	@Expose()
	set isDeleted(v: boolean) { this._isDeleted = v; }
	get isDeleted(): boolean { return this._isDeleted; }

	constructor(json: any = null) {
		super(json);
		if (json) {
			this.originalJson = json;
		}
	}
}

/** A pillar as returned from listPillars — idea + current version + origin. */
export interface PillarWithVersion extends IdeaWithVersion {
	origin: 'admin' | 'community';
}

/** The calling user's vote on a specific pillar version. */
export interface PillarVoteEntry {
	ideaId: string;
	ideaVersionId: string;
	choice: number;  // VoteChoice int enum
	votedAt: string;
}
